import { S3Item } from 'contexts/BucketContext';

import { Image } from 'components/Image';

import * as S from './Gallery.styles';

type GalleryProps = {
  urls: S3Item[];
  deletePhoto: Function;
};

const defaultProps: Partial<GalleryProps> = {};

export function Gallery(props: GalleryProps): React.ReactElement {
  const { urls } = { ...defaultProps, ...props };

  const urlsIntoImages = urls?.map((item: S3Item) => (
    <Image key={item.id} source={item.url} alt={item.key} />
  ));

  return <S.Container>{urlsIntoImages}</S.Container>;
}
